import Footer from "../components/Footer";

export default function Terms() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="text-2xl font-bold">Conditions</h1>
        <div className="prose max-w-3xl">
          <h2>Objet</h2>
          <p>Les présentes conditions encadrent l’utilisation de DawaRedacc.</p>
          <h2>Accès au service</h2>
          <p>Le service est accessible aux utilisateurs disposant d’un compte valide.</p>
          <h2>Crédits & Tarifs</h2>
          <p>Chaque génération consomme des crédits. Les crédits sont remboursés en cas d’échec technique.</p>
          <h2>Propriété intellectuelle</h2>
          <p>Les contenus générés appartiennent au client. Le logiciel et la marque restent la propriété de l’éditeur.</p>
          <h2>Responsabilité</h2>
          <p>Le service est fourni « en l’état ». L’éditeur ne saurait être tenu responsable des usages faits des contenus générés.</p>
          <h2>Résiliation</h2>
          <p>Le client peut résilier à tout moment depuis les réglages. Les données sont supprimées conformément à la politique de confidentialité.</p>
          <h2>Droit applicable</h2>
          <p>Droit français. Tribunal compétent de Paris, à défaut d’accord amiable.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
